// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget = 'submit'

type userContactSupportEventArgs = {
  helpCenterSessionId: string | null
  oldThreadId?: string | null
  newThreadId?: string | null
}

type userContactSupportEventExtraArgs = {
  old_thread_id?: string
  help_center_session_id: string | null
  new_thread_id?: string
}

export const userContactSupportEvent = (args: userContactSupportEventArgs) => {
  const { helpCenterSessionId } = args

  const extra: userContactSupportEventExtraArgs = {
    help_center_session_id: helpCenterSessionId,
  }

  if (args.newThreadId) {
    extra.new_thread_id = args.newThreadId
  }

  if (args.oldThreadId) {
    extra.old_thread_id = args.oldThreadId
  }

  return {
    event: 'user.contact_support',
    extra,
  }
}

type NoticesUserEventArgs = {
  threadId: string
}

type NoticesUserEventExtra = {
  thread_id: string
}

export const noticesUserOpenFaq = (args: NoticesUserEventArgs) => {
  const extra: NoticesUserEventExtra = {
    thread_id: args.threadId,
  }

  return {
    event: 'notices.user.open_faq',
    extra,
  }
}

export const noticesUserOpenContactForm = (args: NoticesUserEventArgs) => {
  const extra: NoticesUserEventExtra = {
    thread_id: args.threadId,
  }

  return {
    event: 'notices.user.open_contact_form',
    extra,
  }
}

export const noticesUserSubmitTicket = (args: NoticesUserEventArgs) => {
  const extra: NoticesUserEventExtra = {
    thread_id: args.threadId,
  }

  return {
    event: 'notices.user.submit_ticket',
    extra,
  }
}

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs) => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}
